const FloatLabel = (() => {
  
  // add active class and placeholder 
  const handleFocus = (e) => {
    const target = e.target;
    target.parentNode.classList.add('active');
  };
  
  // remove active class and placeholder
  const handleBlur = (e) => {
    const target = e.target;
    if(!target.value) {
      target.parentNode.classList.remove('active');
    }
  };  
  
  // register events
  const bindEvents = (element) => {
    const floatField = element.querySelector('.float-container__input');
    floatField.addEventListener('focus', handleFocus);
    floatField.addEventListener('blur', handleBlur);    
  };
  
  // get DOM elements
  const init = () => {
    const floatContainers = document.querySelectorAll('.float-container');
    
    floatContainers.forEach((element) => {
      if (element.querySelector('.float-container__input').value) {
          element.classList.add('active');
      }      
      
      bindEvents(element);
    });
  };
  
  return {
    init: init
  };
})();

FloatLabel.init();


window.addEventListener('pageshow', function(event) {
  var historyTraversal = event.persisted || 
                         (typeof window.performance != 'undefined' && 
                              window.performance.navigation.type === 2);
  if (historyTraversal) {
    document.getElementById('email_signup').reset();
  }
});